import React from 'react';
import './TrendingGiveaways.css';
import CountdownTimer from './CountdownTimer';
import ProgressBar from './ProgressBar';

function TrendingGiveaways({ giveaways = [] }) {
  const trending = giveaways
    .filter(g => g.status === 'active')
    .sort((a, b) => (b.participants || 0) - (a.participants || 0))
    .slice(0, 5);

  if (trending.length === 0) {
    return (
      <div className="trending-giveaways">
        <h2>🔥 Trending Giveaways</h2>
        <p className="empty-message">No active giveaways</p>
      </div>
    );
  }

  return (
    <div className="trending-giveaways">
      <div className="trending-header">
        <h2>🔥 Trending Giveaways</h2>
        <p>Most popular giveaways right now</p>
      </div>
      <div className="trending-list">
        {trending.map((giveaway, index) => {
          const participationRate = giveaway.participants > 0 
            ? Math.min((giveaway.participants / 100) * 100, 100) 
            : 0;
          
          return (
            <div key={giveaway._id || giveaway.id} className="trending-card">
              <div className="trending-rank">
                <span className="rank-number">#{index + 1}</span>
                {index === 0 && <span className="trending-badge">🔥 Hot</span>}
              </div>
              <div className="trending-content">
                <h3>{giveaway.title}</h3>
                <p className="trending-prize">🎁 {giveaway.prize}</p>
                <div className="trending-stats">
                  <span className="stat-item">👥 {giveaway.participants || 0} participants</span>
                  <span className="stat-item">⏰ <CountdownTimer targetDate={giveaway.endsAt} /></span>
                </div>
                <div className="trending-progress">
                  <ProgressBar 
                    value={participationRate} 
                    max={100} 
                    label="Popularity" 
                    color="primary"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TrendingGiveaways;

